/**
 * Routing helpers for the `db/*` and `open/firestoreAction` endpoints.
 *
 * The legacy Cloud Functions were removed, so these helpers now always point to
 * the new API. The legacy base URL parameter is kept in the signatures so the
 * existing callers do not need to change.
 */

/** Full URL of the `db/action` endpoint. */
export function dbActionUrl(_apiUrl: string, newApiUrl: string): string {
  return `${newApiUrl}/api/v1/db/action`
}

/** Full URL of the `open/firestoreAction` endpoint. */
export function openFirestoreActionUrl(_apiUrl: string, newApiUrl: string): string {
  return `${newApiUrl}/api/v1/open/firestoreAction`
}
